import { render, staticRenderFns } from "./Ubicazioni.vue?vue&type=template&id=07ba3048&"
import script from "./Ubicazioni.vue?vue&type=script&lang=js&"
export * from "./Ubicazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports